import React from "react";
import { Text, Button, ModalFooter } from "@nef/core";

import StyledFormErrorModal from "../../../../styles/FormErrorModal.styles";
import { NFN_OPS_EMAIL, NFN_OPS_EMAIL_HREF } from "../../../../constants/common";

const FormErrorModal = (props: any) => {
  const { isValidationModalOpen, setValidationModalOpen } = props;

  return (
    <>
      <StyledFormErrorModal
        className="form-error-modal"
        size="lg"
        closeOnOutsideClick={true}
        isOpen={isValidationModalOpen}
        toggle={() => {
          setValidationModalOpen(false);
        }}
      >
        <Text className="text">
          Your form cannot be completed. Please contact{" "}
          <a href={NFN_OPS_EMAIL_HREF}>{NFN_OPS_EMAIL}</a> to finish
          registration process.
        </Text>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              setValidationModalOpen(false);
            }}
          >
            Back
          </Button>
        </ModalFooter>
      </StyledFormErrorModal>
    </>
  );
};

export default FormErrorModal;
